import { Stack } from "@bookingcom/bui-react";
import { useCampaignImpactQuery } from "../../hooks/useCampaignImpactQuery";
import { useAirlinesCampaignImpactQuery } from "../../hooks/useAirlinesCampaignImpactQuery";
import { useAuth } from "../../hooks/useAuth";
import { CampaignImpactCards } from "./CampaignImpactCards";
import { CampaignImpactInfoBox } from "./CampaignImpactInfoBox";
import type { CampaignImpactKpi, CampaignImpactMetadata } from "../../types";
import { useSelectedAirline } from "../../hooks/useSelectedAirline";

type CampaignImpactContentProps = {
  kpis: CampaignImpactKpi[];
  metadata?: CampaignImpactMetadata;
  isError?: boolean;
};

export const CampaignImpactContent = ({ metadata, kpis, isError }: CampaignImpactContentProps) => (
  <Stack direction="column" gap={4}>
    <CampaignImpactCards metadata={metadata} kpis={kpis} />
    <CampaignImpactInfoBox metadata={metadata} kpis={kpis} isError={isError} />
  </Stack>
);

type CampaignImpactLoaderProps = {
  period: string;
};

export const CampaignImpactLoader = ({ period }: CampaignImpactLoaderProps) => {
  const { isAirlineUser } = useAuth();
  const { selectedAirline } = useSelectedAirline({ useSuspense: true });
  const useQuery = isAirlineUser ? useCampaignImpactQuery : useAirlinesCampaignImpactQuery;
  const {
    data: { metadata, kpis },
  } = useQuery({ period, airlineCode: selectedAirline?.code ?? "" });

  return <CampaignImpactContent metadata={metadata} kpis={kpis} />;
};
